import { format } from 'date-fns';
import I18n, { TranslateOptions } from 'i18n-js';
import moment from 'moment';
import { API } from './API';
import { LangText } from './interfaces';
import { Category, Clinic, Horario } from './interfaces/index';

export { API };

export function I18nt(text: LangText, options?: TranslateOptions) {
	return I18n.t(text, options);
}

export function lettersOnly(str: string) {
	return str.replace(
		// eslint-disable-next-line no-useless-escape
		/[`~!@#$%^&*()_|+\-=?;:'",.0-9<>\{\}\[\]\\\/]/gi,
		''
	);
}

export function numbersOnly(str: string) {
	return str.replace(
		// eslint-disable-next-line no-useless-escape
		/[`~!@#$%^&*()_|+\-=?;:'",.a-zA-Z<>\{\}\[\]\\\/]/gi,
		''
	);
}

export function formatDUI(dui: string) {
	const txt = [...numbersOnly(dui).split('')];
	if (txt.length > 8) {
		txt.splice(8, 0, '-');
	} else {
		txt.join('').replace('-', '');
	}
	return txt.join('');
}

export function formatPhone(phone: string) {
	const txt = [...numbersOnly(phone).split('')];
	if (txt.length > 4) {
		txt.splice(4, 0, '-');
	} else {
		txt.join('').replace('-', '');
	}
	return txt.join('');
}

export const range = (start: number, stop: number, step = 1) => 
  Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));

const daysString = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];

const getHorario = (dateString: string, horarios: Horario[] = []): Horario | undefined => {
  const [year, month, day] = dateString.split('-');
  const date = new Date(Number(year), Number(month) -1, Number(day));
  return horarios.find((h) => h.diaSemana === daysString[date.getDay()]);
};

export function getAvailableHours(
  busyHours: { fechaCita: string }[],
  dateString: string,
  clinic?: Clinic,
) {
  if(!clinic) return [];
  const horario = getHorario(dateString, clinic.horario);
	const busyFormattedHours = busyHours.map((value) => {
		return value.fechaCita.split(' ')[1]; //get only hours
	});
  const hours = range(horario?.horaInicio as number, horario?.horaFin as number, 1);
	const availableHours = hours.reduce((acc: string[], current) => {
		const hour = moment({ hour: current }).format('HH:mm:ss');
		if (!busyFormattedHours.includes(hour)) return [...acc, hour];
		return acc;
	}, []);
	return availableHours;
}

export function formatTime(time?: string) {
	if (!time) {
		return '00:00';
	}
	const date = new Date(`2000/1/1 ${time}`);
	return format(date, 'hh:mm a').toLowerCase();
}

export function getAvailableHours15minutes(
  busyHours: { fechaCita: string }[],
  dateString: string,
  clinic?: Clinic,
) {
  if(!clinic) return [];
  const horario = getHorario(dateString, clinic.horario);
	const busyFormattedHours = busyHours.map((value) => {
		return value.fechaCita.split(' ')[1]; //get only hours
	});
  const hours = range(horario?.horaInicio as number, horario?.horaFin as number, 1);
	const availableHours = hours.reduce((acc: string[], current) => {
		const minutes = [0, 15, 30, 45]; //Valid Minutes
		const validHours = minutes.reduce(
			(accMinutes: string[], currentMinutes) => {
				const hour = moment({ hour: current, minutes: currentMinutes }).format(
					'HH:mm:ss'
				);
				if (!busyFormattedHours.includes(hour)) return [...accMinutes, hour];
				return accMinutes;
			},
			[]
		);
		return [...acc, ...validHours];
	}, []);
	return availableHours;
}

export function getAvailableHoursDoctors(
  busyHours: { fechaCita: string }[],
  dateString: string,
  category?: Category,
) {
  if(!category) return [];
  const horario = getHorario(dateString, category.horario);
  
	const busyFormattedHours = busyHours.map((value) => {
		return value.fechaCita.split(' ')[1]; //get only hours
	});
  const hours = range(horario?.horaInicio as number, horario?.horaFin as number, 1);
	const availableHours = hours.reduce((acc: string[], current) => {
		const hour = moment({ hour: current }).format('HH:mm:ss');
		if (!busyFormattedHours.includes(hour)) return [...acc, hour];
		return acc;
	}, []);
	return availableHours;
}
